'use client';

import { useOptionalRenderContext } from '@/lib/render/RenderContextProvider';
import { Text } from '@/lib/render/Text';

/**
 * The article's intro paragraph ("Anreißer"), at the position an editor gave
 * this block on the article Template Page (spec 10.03.02.02.08).
 *
 * Through `<Text field="intro">` rather than as plain text, so the Strapi
 * preview's inline editing of `intro` keeps working.
 */
export const MagazineTeaserTextComponent = () => {
  const ctx = useOptionalRenderContext();

  // Inert on any other Page and empty in a Template Page preview: no other
  // route puts an article in the render context.
  if (!ctx?.entities.article) {
    return null;
  }

  return (
    // Rendered in full — never clamped or truncated (10.02.03 § AC 3 row 4).
    <div>
      <Text as="p" field="intro" className="text-center text-lg">
        {ctx.entities.article.intro}
      </Text>
    </div>
  );
};
